<template>
   <div>
      <!-- 头部 -->
      <Header :title="title" :showBack="true"></Header>

      <!-- 支付方式选择 -->
      <van-popup v-model="payTypeShow" position="bottom" :style="{ height: '30%' }">
         <PayTypeSelect :orderNo="orderInfo.OrderNo"></PayTypeSelect>
      </van-popup>


      <section class="history-wrap">
         <div class="warning-wrap wrap">
            <span class="iconfont iconjinggao"></span>
            <span class="warning-text">订单已存在</span>
         </div>
         <p class="wrap-title">订单详情</p>
         <div class="order-wrap wrap">
            <ul class="line-info">
               <li class="linename">{{ orderDetail.LineName }}</li>
               <li class="classtime">{{ orderDetail.ClassTime }}</li>
            </ul>
            <ul class="order-info">
               <li>
                  <div class="order-field">订单号：</div>
                  <div class="order-value">{{ orderInfo.OrderNo }}
                     <span v-if="orderInfo.OrderSource">（来源：{{ orderInfo.OrderSource }}）</span>
                  </div>
               </li>
               <li>
                  <div class="order-field">订单状态：</div>
                  <div class="order-value">{{ orderDetail.PayTypeName }}</div>
               </li>
               <li>
                  <div class="order-field">下单人：</div>
                  <div class="order-value">{{ orderDetail.CustName }}</div>
               </li>
               <li>
                  <div class="order-field">下单时间：</div>
                  <div class="order-value">{{ orderInfo.CreateTime }}</div>
               </li>
               <li>
                  <div class="order-field">行程：</div>
                  <div class="order-value node-info">
                     <div>{{ orderDetail.StartNodeName }}</div>
                     <div class="leave-for"></div>
                     <div>{{ orderDetail.ArrivalNodeName }}</div>
                  </div>
               </li>
            </ul>
         </div>
         <ul class="btn-list">
            <li class="btn-pay" @click="continuePay">
               <span>继续支付</span>
            </li>
            <li class="btn-cancel" @click="ticketOrderCancel">
               <span>取消订单</span>
            </li>
         </ul>
         <p class="wrap-title">坐车人信息</p>
         <ul class="custinfo-wrap wrap">
            <li v-for="(item, index) in orderDetailList" :key="index">
               <div class="custinfodetail-wrap">
                  <div class="custinfodetail">
                     <div class="custinfodetail-field">
                        <span>乘车人</span>
                     </div>
                     <div class="custinfodetail-value">
                        <p>{{ item.CustName }}</p>
                        <p>{{ item.CustTel }}</p>
                     </div>
                  </div>
                  <div class="custinfodetail">
                     <div class="custinfodetail-field">
                        <span>证件信息</span>
                     </div>
                     <div class="custinfodetail-value">
                        <p class="custCert-type">{{ item.CustCertType }}</p>
                        <p>{{ item.CustCertNo }}</p>
                     </div>
                  </div>
               </div>
               <div class="seatinfo-wrap">
                  <div class="seatinfo">
                     <p class="seatno">{{ item.SeatNo }}</p>
                     <p class="tickettype">{{ item.TicketTypeName }}</p>
                  </div>
               </div>
            </li>
         </ul>
      </section>
   </div>
</template>

<script>
import Header from "@/components/Header/Header.vue";
import PayTypeSelect from "@/components/Common/PayTypeSelect.vue";
export default {
   components: {
      Header,
      PayTypeSelect
   },
   data() {
      return {
         historyOrderInfo: JSON.parse(window.localStorage.getItem('historyOrder'))[0],
         title: '订单历史',
         orderInfo: {},
         orderDetailList: [],
         payTypeShow: false, // 展示可选择支付方式
         OperObj: JSON.parse(window.localStorage.getItem("adminInfo")), // 操作员 对象
      }
   },
   computed: {
      orderDetail() {
         return this.orderDetailList[0] || {};
      }
   },
   methods: {
      // 获取订单信息
      getTicketOrder() {
         const now = new Date();
         const beginDate = this.$moment(now).format('YYYY-MM-DD 00:00:00');
         const endDate = this.$moment(now).add('days', 45).format('YYYY-MM-DD 23:59:59');
         this.$http.post(this.$api.TicketOrderQuery, {
            OrderNo: this.historyOrderInfo.OrderNo,
            BeginDate: beginDate,
            EndDate: endDate
         }).then(res => {
            this.orderInfo = res.data[0];
         })
      },

      // 获取订单明细
      getTicketOrderDetail() {
         this.$http.post(this.$api.getTicketOrderDetail, {
            OrderGID: this.historyOrderInfo.OrderGID
         }).then(res => {
            this.orderDetailList = res.data;
         })
      },

      // 继续支付
      continuePay() {
         //如果当前渠道与订单渠道不同，不允许继续支付，需取消重新下单
         if (this.orderInfo.AgentAppID != this.$utils.getSysParams("WindowSaleAgentAppID")) {
            this.$toast("当前渠道与订单渠道不同，请取消订单后重新下单！");
         } else {
            this.payTypeShow = true;
         }
      },

      // 取消订单
      ticketOrderCancel() {
         let param = {
            AgentAppID: this.$utils.getSysParams("WindowSaleAgentAppID"), //渠道appid
            OrderNo: this.orderInfo.OrderNo,
            OrderDetailGIDList: this.orderDetailList.map(d => d.GID).join(','),
            OperGID: this.OperObj.GID, //操作员GID
            OperCode: this.OperObj.UserCode, //操作员代码
            OperName: this.OperObj.UserName, //操作员名称
         };
         this.$http.post(this.$api.onTicketCancel, param).then(res => {
            if (res.success) {
               this.$toast("取消成功");
               setTimeout(() => {
                  this.$router.back(-1);
               }, 1000);
            } else {
               this.$toast("取消失败：" + res.msg);
            }
         })
      }
   },
   created() {
      this.getTicketOrder();
      this.getTicketOrderDetail();
   }
}
</script>

<style>
:root {
   --HistoryOrder--padding: .2564rem;
}
</style>

<style lang="less" scoped>
.history-wrap {
   padding: var(--HistoryOrder--padding);
   text-align: left;

   .wrap {
      border-radius: 5px;
      padding: var(--HistoryOrder--padding);
      background: white;
      margin-bottom: var(--HistoryOrder--padding);
      border: 1px solid #ddd;
   }

   .wrap-title {
      margin-bottom: .1282rem;
   }

   .warning-wrap {
      font-weight: bold;
      color: #d73886;

      .iconjinggao {
         color: #d73886;
      }

      .warning-text {
         margin-left: .1282rem;
         font-size: .4359rem;
      }
   }

   .order-wrap {
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      margin-bottom: 0;
      border-radius: 10px 10px 0 0;

      .line-info {
         border-bottom: 1px solid #ccc;
         padding: 0 var(--HistoryOrder--padding) var(--HistoryOrder--padding);
         display: flex;
         justify-content: space-between;
         color: #ff9e3d;
         font-weight: bold;

         .linename {
            font-size: .4872rem;
         }

         .classtime {
            font-size: .4615rem;
         }
      }

      .order-info {
         padding: var(--HistoryOrder--padding);
         padding-bottom: .1282rem;
         font-size: .359rem;

         li {
            border-bottom: 1px solid #ccc;
            padding: .2051rem 0;
            display: flex;
            align-items: center;

            &:nth-last-child(1) {
               border: 0;
            }

            .order-field {
               width: 2.0513rem;
               color: #777;
            }

            .order-value {
               &.node-info {
                  font-size: .4615rem;
                  color: #ff9933;
                  display: flex;
                  width: 100%;
                  text-align: center;

                  div {
                     flex: 1;
                  }

                  .leave-for {
                     width: 15%;
                     position: relative;

                     &::before {
                        content: '';
                        top: 50%;
                        left: 0;
                        transform: translate(0, -50%);
                        position: absolute;
                        width: 95%;
                        height: 3px;
                        background: #ff9933;
                     }

                     &::after {
                        content: '';
                        top: calc(50% - .107rem);
                        right: 0;
                        transform: translate(0, -50%) rotate(45deg);
                        position: absolute;
                        width: .3846rem;
                        height: 3px;
                        background: #ff9933;
                     }

                     flex: unset;
                  }
               }
            }
         }
      }
   }

   .btn-list {
      display: flex;
      text-align: center;
      font-size: .4615rem;
      font-weight: bold;
      background: transparent;
      margin-bottom: .2051rem;

      li {
         flex: 1;
         padding: .2564rem 0;
         border-radius: 0 0 8px 8px;
         background: #fff;
         border: 1px solid #ddd;

         &.btn-pay {
            color: #009900;
         }

         &.btn-cancel {
            color: #ff3401;
         }
      }
   }

   .custinfo-wrap {
      font-size: .359rem;

      >li {
         display: flex;
         justify-content: space-between;
         padding: .2564rem 0;
         border-bottom: 1px solid #ddd;

         .custinfodetail-wrap {
            .custinfodetail {
               display: flex;
               line-height: .641rem;

               &:nth-child(1) {
                  margin-bottom: .2564rem;
               }

               .custinfodetail-field {
                  width: 1.7949rem;
               }

               .custCert-type {
                  color: #aaa;
               }
            }
         }

         .seatinfo-wrap {
            display: flex;
            align-items: center;

            .seatinfo {
               border: 1px solid #aaa;
               border-radius: 5px;
               min-width: 1.2821rem;
               text-align: center;

               p {
                  padding: .0769rem 0;

                  &:nth-child(1) {
                     border-bottom: 1px solid #aaa;
                  }
               }
            }
         }

         &:nth-last-child(1) {
            border-bottom: 0;
         }
      }
   }
}
</style>